import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(message) {
        this.message_1 = message;
        this.locations_1 = null;
        this.path_1 = null;
        this.nonStandardFields_1 = null;
        this.extensions_1 = null;
      }
      locations_dffcqo_k$(locations) {
        // Inline function 'kotlin.apply' call
        this.locations_1 = locations;
        return this;
      }
      path_rwdaoz_k$(path) {
        // Inline function 'kotlin.apply' call
        this.path_1 = path;
        return this;
      }
      extensions_sh2glh_k$(extensions) {
        // Inline function 'kotlin.apply' call
        this.extensions_1 = extensions;
        return this;
      }
      nonStandardFields_tmp1ka_k$(nonStandardFields) {
        // Inline function 'kotlin.apply' call
        this.nonStandardFields_1 = nonStandardFields;
        return this;
      }
      build_1k0s4u_k$() {
        return new (Error_0())(this.message_1, this.locations_1, this.path_1, this.extensions_1, this.nonStandardFields_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var LocationClass;
function Location() {
  if (LocationClass === VOID) {
    class $ {
      constructor(line, column) {
        this.line_1 = line;
        this.column_1 = column;
      }
      toString() {
        return 'Location(line = ' + this.line_1 + ', column = ' + this.column_1 + ')';
      }
    }
    initMetadataForClass($, 'Location');
    LocationClass = $;
  }
  return LocationClass;
}
var ErrorClass;
function Error_0() {
  if (ErrorClass === VOID) {
    class $ {
      constructor(message, locations, path, extensions, nonStandardFields) {
        this.message_1 = message;
        this.locations_1 = locations;
        this.path_1 = path;
        this.extensions_1 = extensions;
        this.nonStandardFields_1 = nonStandardFields;
      }
      toString() {
        return 'Error(message = ' + this.message_1 + ', locations = ' + toString(this.locations_1) + ', path=' + toString(this.path_1) + ', extensions = ' + toString(this.extensions_1) + ', nonStandardFields = ' + toString(this.nonStandardFields_1) + ')';
      }
    }
    initMetadataForClass($, 'Error');
    ErrorClass = $;
  }
  return ErrorClass;
}
//region block: exports
export {
  Builder as Builder3gaff1pwujyid,
  Location as Location25t453jk43ktl,
};
//endregion

//# sourceMappingURL=Error.mjs.map
